import { useNavigate } from "react-router-dom";

import { ActionButton, useTheme } from "@bps/fluent-ui";

import { navBarActionButtonStyles } from "../../layout/nav-bar/nav-bar.styles";
import { routes } from "../routes/routes";

export const NavBarSettings = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <ActionButton
      iconProps={{ iconName: "Settings" }}
      onClick={() => {
        navigate(routes.settings.home.path);
      }}
      styles={navBarActionButtonStyles(theme)}
    />
  );
};
